import { toSuccess } from '../../resolvers/definition/resolverState';
export const pushFromData = transform => ({
  dataChanged,
  self,
  other
}) => {
  var _self$state, _other$state;
  if (!((_self$state = self.state) !== null && _self$state !== void 0 && _self$state.data) || !dataChanged) {
    return;
  }
  const data = transform({
    self: {
      data: self.state.data,
      params: self.params,
      context: self.context
    },
    other: {
      data: (_other$state = other.state) === null || _other$state === void 0 ? void 0 : _other$state.data,
      params: other.params,
      context: other.context
    }
  });
  if (data != null) {
    return toSuccess(data)();
  }
};
export const pullFromData = transform => ({
  dataChanged,
  self,
  other
}) => {
  var _other$state2, _self$state2;
  if (!((_other$state2 = other.state) !== null && _other$state2 !== void 0 && _other$state2.data) || !dataChanged) {
    return;
  }
  const data = transform({
    self: {
      data: (_self$state2 = self.state) === null || _self$state2 === void 0 ? void 0 : _self$state2.data,
      params: self.params,
      context: self.context
    },
    other: {
      data: other.state.data,
      params: other.params,
      context: other.context
    }
  });
  if (data != null) {
    return toSuccess(data)();
  }
};

/** @deprecated Use `pushFromData` */
export const transformToTarget = pushFromData;

/** @deprecated Use `pullFromData` */
export const transformToSource = pullFromData;